/* The depot scope switcher. Every register in the app is filtered by it, so it
   lives above the screens rather than being reimplemented in each one. */

import { createContext, useContext } from 'react';
import type { DepotScope } from '../models';

export interface DepotScopeValue {
  scope: DepotScope;
  setScope: (scope: DepotScope) => void;
}

export const DepotScopeContext = createContext<DepotScopeValue>({
  scope: 'all',
  setScope: () => undefined,
});

export function useDepotScope(): DepotScopeValue {
  return useContext(DepotScopeContext);
}

/** True when a record at `loc` is visible under the current scope. */
export function inScope(scope: DepotScope, loc: string | null | undefined): boolean {
  if (scope === 'all') return true;
  return loc === scope;
}

/** Filters any collection carrying a `loc`. */
export function scoped<T extends { loc: string }>(rows: T[], scope: DepotScope): T[] {
  return scope === 'all' ? rows : rows.filter((r) => r.loc === scope);
}
